import React, {ReactNode, useEffect} from 'react';
import '../index.scss';
import {BlockUIState} from '../../../redux/@types/blockUI';
import BlockUIService from '../../../services/blockUIService';
import {BlockUI} from 'primereact/blockui';
import {ProgressSpinner} from 'primereact/progressspinner';
import {Toast} from 'primereact/toast';
import ToastService from '../../../services/toastService';
import {Card} from 'primereact/card';
import {InputText} from 'primereact/inputtext';
import {Password} from 'primereact/password';
import AnttButton from '../../../components/Button';
import LoginFilter from '../model/LoginFilter';
import LoginController from '../controller/login.controller';
import Environment from '../../../../environments/environment';

interface Props {
  children: ReactNode;
}

const Auth: React.FC<Props> = ({children}) => {

  const filterLogin = new LoginFilter();
  const controller = new LoginController(filterLogin);
  const blockUI: BlockUIState = new BlockUIService().getCurrentState();


  useEffect(() => {
  }, []);

  return (
    <BlockUI
      blocked={blockUI.blocked}
      template={<ProgressSpinner/>}
      autoZIndex={true}
      baseZIndex={6000}
      fullScreen
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
          controller.logar();
        }}
      >
        <Toast baseZIndex={10002} ref={(el) => ToastService.init(el)} style={{paddingTop: 40}}/>
        <div className="login-wrapper">
          <div className="login-landscape" style={{backgroundImage: 'url(/images/antt-bg.png)'}}>
            <div>
              <h1>{Environment.getNomeSistema()}</h1>
              <h1 style={{textAlign: 'right'}}>{Environment.getVersaoSistema()}</h1>
            </div>
          </div>
          <div className="login-form">
            <div className="login-card-wrapper">
              <Card>
                <div className="login-card-form">
                  <h1 className="titulo-institucional">Entrar</h1>
                  <div className="login-input-email">
                    <label>Nome de usuário</label>
                    <InputText
                      size={51}
                      value={filterLogin.usuario}
                      onChange={(e) => filterLogin.setUsuario(e.target.value)}
                    />
                  </div>
                  <div className="login-input-senha">
                    <label>Senha</label>
                    <Password
                      size={51}
                      feedback={false}
                      toggleMask
                      onKeyDown={(e) => e.keyCode == 13 && controller.logar()}
                      value={filterLogin.senha}
                      onChange={(e) => filterLogin.setSenha(e.target.value)}
                    />
                  </div>
                  <div>
                    <AnttButton
                      style={{margin: '0'}}
                      className="acesso-interno"
                      type="submit"
                      label="Fazer login"/>
                    <AnttButton
                      style={{marginTop: '20px'}}
                      className="gov-br"
                      type="button"
                      onClick={() => controller.history.push('/login/unico')}
                      label="Acesso gov.br"/>
                    <AnttButton
                      type="button"
                      style={{marginTop: '10px'}}
                      onClick={() => controller.history.push('/public')}
                      className="p-button-secondary"
                      label="Voltar"/>

                  </div>
                </div>
              </Card>
            </div>
            <footer>
              
              <img src="/images/logo-sutec.png"/>
              <img src="/images/logo-govern-regulat.png"/>
              <img src="/images/logo-antt.png"/>
            </footer>
          </div>
        </div>
      </form>
    </BlockUI>
  );
}
export default Auth;
